import {Component, ViewChild, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-admincentro-escolar-cursos',
  templateUrl: './admincentro-escolar-cursos.component.html',
  styleUrls: ['./admincentro-escolar-cursos.component.scss']
})
export class AdmincentroescolarCursosComponent implements OnInit {

  user;
  userId = '';
  ampa;

  // datos de la tabla
  displayedColumns = ['select','codigo', 'curso',  'nivel', 'grupo',  'tutor', 'emailtutor', 'acciones'];

  selection = new SelectionModel<CursosData>(true, []);
  dataSource: MatTableDataSource<CursosData>;
  cursos: CursosData[] = [];
  initialSelection = [];
  allowMultiSelect = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public map: any = { lat: 39.944204, lng: 0.091394 };

  constructor( private router: Router ) {
    console.log('constructor')
  }

   ngOnInit() {
     console.log('ngoninit')
     this.dataSource = new MatTableDataSource(this.cursos);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     //obtener datos del usuario admin logueado
     this.userId = localStorage.getItem('userId');
     console.log('UserId', this.userId);
     if(!this.userId){
       this.router.navigate[('')]
     } else {
       firebase.firestore().collection('admins').doc(this.userId)
       .get()
       .then((doc)=>{
         this.user = doc.data();
         console.log('User', this.user)

         this.obtenerCursos();
       })
     }
  }

  // nos traemos los cursos del ampa utilizando el id de ampa que tiene el usuario en su documento
  obtenerCursos(){
    console.log('obtenerCursos')
    firebase.firestore().collection('cursos')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{

      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        //var elemento: CursosData;
        var elemento = doc.data();
        elemento.id = doc.id;
        //hacemos el push
        this.cursos = [...this.cursos, <CursosData>elemento];
      })
      this.dataSource = new MatTableDataSource(this.cursos);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }

  // mostramos los datos del curso id
  ver(row){
    console.log('Ver ', row.id);
    this.router.navigate(['/admin/centro-escolar-cursos/ver/' + row.id]);
  }

  // eliminar cursos seleccionados
  eliminar(){
      this.selection.selected.forEach((curso) => {
        firebase.firestore().collection('cursos').doc(curso.id)
        .delete()
        .catch(error => {console.log(error); })
        .then(()=>{
          console.log('Borrado curso ' + curso.id)
        })
      });
      this.cursos = [];
      this.obtenerCursos();
  }

  // actualizamos los datos de algunos campos del curso id
  editar(row){
    console.log('Editado ', row.id)
    this.router.navigate(['/admin/centro-escolar-cursos/editar/' + row.id])
  }

  //exportamos a xlsx datos de cursos seleccionados
  exportToExcel() {
    var ws = XLSX.utils.json_to_sheet(this.selection.selected);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cursos");
    XLSX.writeFile(wb, 'cursos.xlsx');
  }

  exportToPDF() {

  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

}

export interface CursosData {
  id: string;
  codigo: string;
  curso: string;
  nivel: string;
  grupo: string;
  tutor: string;
  emailtutor: string;
}



// WEBPACK FOOTER //
// ./src/app/admincentro-escolar-cursos/admincentro-escolar-cursos.component.ts